import * as compareWidget from '../components/compare-widget';
import progress from '../utils/progress';
import util from '../utils/util';
import uniform from '../components/uniform';
import tracking from '../components/tracking/tracking';
import {init as initMobilerefinements} from '../components/category/mobilerefinements';
import lazyload from '../utils/lazyload';
import {isMac, isDeviceiOS} from '../utils/iOS';
import {
    handleLoadMore as handleLoadMoreConstructor,
    handleRefinements as handleRefinementsConstructor,
    handleSort as handleSortConstructor
} from '../constructor-io/search/event-handlers';
import ConstructorIOSearch from '../constructor-io/search';
import cookie from '../components/cookie';
import wishlist from './wishlist';
import {init as colorSwatchInit} from './search-results/colorswatch';
import {
    applyShowMoreProductsStyle,
    finiteScroll,
    getRefinementsType,
    initSizeTabs,
    reInitSections,
    reInitTiles,
    removeScrollPosition,
    updateCustomDropdown
} from './search-results/helper';
import {init as productTileInit} from './search-results/product-tile';

const LAST_VISITED_SEARCH_COOKIE = 'LastVisitedSearch';

const $window = $(window);
let scrollOffset;

/**
 * Stores the page scroll position in the session storage
 */
function storeScrollPosition() {
    const scrollTop = $window.scrollTop();
    const {currentPage} = finiteScroll;

    // first delete previously stored scroll information
    removeScrollPosition();
    sessionStorage.setItem(`pageLocationPosition_${encodeURIComponent(window.location.href)}`, scrollTop);
    sessionStorage.setItem(`pageLocationPagingSite_${encodeURIComponent(window.location.href)}`, currentPage);
}

/**
 *
 */
function infiniteScroll() {
    // getting the hidden div, which is the placeholder for the next page
    const $loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    const gridUrl = $loadingPlaceHolder.attr('data-grid-url');
    let fillEndlessScrollChunk;
    const notDisabled = false;

    if ($loadingPlaceHolder.length === 1 && util.elementInViewport($loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        $loadingPlaceHolder.attr('data-loading-state', 'loading');
        $loadingPlaceHolder.addClass('infinite-scroll-loading');

        /**
         * named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
         *
         * @param {string} html - html
         */
        fillEndlessScrollChunk = function (html) {
            $loadingPlaceHolder.removeClass('infinite-scroll-loading');
            $loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content').append(html);
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649
        if (notDisabled) {
            // if we hit the cache
            fillEndlessScrollChunk(sessionStorage[`scroll-cache_${gridUrl}`]);
        } else {
            // else do query via ajax
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: gridUrl,
                /**
                 * @param {string} response - response
                 */
                success(response) {
                    // put response into cache
                    try {
                        sessionStorage[`scroll-cache_${gridUrl}`] = response;
                    } catch (ignore) {
                        // nothing to catch in case of out of memory of session storage
                        // it will fall back to load via ajax
                    }
                    // update UI
                    fillEndlessScrollChunk(response);
                    productTileInit();
                    lazyload.init();
                    uniform();
                }
            });
        }
    }
}

/**
 * @private
 * @function
 * @description BSDDEV-2090 restore displayed products and scroll position
 */
function updateHistoryWithAdditionalProducts() {
    // get the paging url
    const $loadingPlaceHolder = $('.show-more-products-placeholder[data-loading-state="unloaded"]');
    let gridUrl = $loadingPlaceHolder.attr('data-grid-url');
    // get the current product count
    const pageStart = parseInt(util.getParameterByName('start', gridUrl));
    const pageSize = SitePreferences.loadPageSize;
    const nextPageStart = pageStart + pageSize;

    const removeParams = ['format', 'sz', 'start'];
    if (nextPageStart && !Number.isNaN(nextPageStart) && window.history && window.history.replaceState) {
        // update params
        removeParams.forEach(function (param) {
            gridUrl = util.removeParamFromURL(gridUrl, param);
        });
        gridUrl = util.appendParamsToUrl(gridUrl, {
            sz: nextPageStart
        });
        // update history to display all currently visible products on browser-back
        window.history.replaceState(window.history.state, document.title, gridUrl);
    }
}

/**
 * @private
 * @function
 * @description load additional products to the grid
 */
function loadAdditionalProducts() {
    // getting the hidden div, which is the placeholder for the next page
    const $loadingPlaceHolder = $('.show-more-products-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    let gridUrl = $loadingPlaceHolder.attr('data-grid-url');
    let fillEndlessScrollChunk;
    const notDisabled = false;
    const $additionalProdButton = $('.show-more-products-button');

    $additionalProdButton.find('button .load-more-text').css('visibility', 'hidden');
    if ($loadingPlaceHolder.length === 1) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        $loadingPlaceHolder.attr('data-loading-state', 'loading');
        $loadingPlaceHolder.addClass('additional-products-loading');

        gridUrl += '&loadMoreProducts=true';

        /**
         * named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
         *
         * @param {string} html - html
         */
        fillEndlessScrollChunk = function (html) {
            $loadingPlaceHolder.removeClass('additional-products-loading');
            $loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $additionalProdButton.remove();
            $('div.js-search-result-content').append(html);
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649
        if (notDisabled) {
            // if we hit the cache
            fillEndlessScrollChunk(sessionStorage[`scroll-cache_${gridUrl}`]);
        } else {
            // else do query via ajax
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: gridUrl,
                /**
                 * @param {string} response response
                 */
                success(response) {
                    // put response into cache
                    try {
                        sessionStorage[`scroll-cache_${gridUrl}`] = response;
                    } catch (ignore) {
                        // nothing to catch in case of out of memory of session storage
                        // it will fall back to load via ajax
                    }
                    // update UI
                    fillEndlessScrollChunk(response);
                    // update currentPage
                    finiteScroll.currentPage = Number(finiteScroll.currentPage) + 1;
                    reInitTiles();
                }
            });
        }
    }
}

/**
 * @private
 * @function
 * @description returns state object for refinebar displaying
 * @returns {Object} refinement config
 */
function getRefConfig() {
    const $refinementBar = $('.refinements');
    const urlExtensionObject = $refinementBar.length > 0 ? $refinementBar.data('refconfig') : {};

    return urlExtensionObject;
}

/**
 * @param {JQuery} $refBar - refinement bar element
 * @private
 * @function
 * @description make all refinements of the refinement bar visible
 */
function showAllFilters($refBar) {
    let $refinements;
    let $showMoreLink;
    let $hideMoreLink;
    let $refinementBar;
    let urlExtensionObject;
    if ($refBar !== 'undefined') {
        $refinements = $refBar.find('li.refinement');
        $showMoreLink = $refBar.find('a.show-more-refinements');
        $hideMoreLink = $refBar.find('a.hide-more-refinements');
        $refinementBar = $('.refinements');
        urlExtensionObject = $refinementBar.length > 0 ? $refinementBar.data('refconfig') : {};

        $refinements.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');
        $showMoreLink.removeClass('visible').addClass('visually-hidden');
        $hideMoreLink.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');

        if ($refinementBar.length > 0) {
            urlExtensionObject.showAllRef = 'true';
            $refinementBar.attr('data-refconfig', JSON.stringify(urlExtensionObject));
        }
    }
}

/**
 * @param {JQuery} $refBar - refinement bar element
 * @private
 * @function
 * @description make additional refinements of the refinement bar invisible
 */
function hideAllFilters($refBar) {
    let $refinements;
    let $showMoreLink;
    let $hideMoreLink;
    let $refinementBar;
    let urlExtensionObject;
    if ($refBar !== 'undefined') {
        $refinements = $refBar.find('li.refinement');
        $showMoreLink = $refBar.find('a.show-more-refinements');
        $hideMoreLink = $refBar.find('a.hide-more-refinements');
        $refinementBar = $('.refinements');
        urlExtensionObject = $refinementBar.length > 0 ? $refinementBar.data('refconfig') : {};

        $refinements.not('.allways-visible').removeClass('visible').addClass('visually-hidden');
        $showMoreLink.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');
        $hideMoreLink.removeClass('visible').addClass('visually-hidden');

        if ($refinementBar.length > 0) {
            delete urlExtensionObject.showAllRef;
            $refinementBar.attr('data-refconfig', JSON.stringify(urlExtensionObject));
        }
    }
}

/**
 * @param {JQuery} $valList - value list
 * @private
 * @function
 * @description make all values of the attribute visible
 */
function showAllValues($valList) {
    let $refinementValues;
    let $showMoreLink;
    let $hideMoreLink;
    let refParameter;
    let $refinementBar;
    let urlExtensionObject;
    if ($valList !== 'undefined') {
        $refinementValues = $valList.find('li');
        $showMoreLink = $valList.find('a.show-more-values');
        $hideMoreLink = $valList.find('a.hide-more-values');
        refParameter = `expand_${$valList.data('attrid')}`;
        $refinementBar = $('.refinements');
        urlExtensionObject = $refinementBar.length > 0 ? $refinementBar.data('refconfig') : {};

        $refinementValues.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');
        $showMoreLink.removeClass('visible').addClass('visually-hidden');
        $hideMoreLink.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');

        if ($refinementBar.length > 0) {
            urlExtensionObject[refParameter] = 'true';
            $refinementBar.attr('data-refconfig', JSON.stringify(urlExtensionObject));
        }
    }
}

/**
 * @param {JQuery} $valList - value list
 * @private
 * @function
 * @description make additional values of the attribute invisible
 */
function hideAllValues($valList) {
    let $refinementValues;
    let $showMoreLink;
    let $hideMoreLink;
    let refParameter;
    let $refinementBar;
    let urlExtensionObject;
    if ($valList !== 'undefined') {
        $refinementValues = $valList.find('li');
        $showMoreLink = $valList.find('a.show-more-values');
        $hideMoreLink = $valList.find('a.hide-more-values');
        refParameter = `expand_${$valList.data('attrid')}`;
        $refinementBar = $('.refinements');
        urlExtensionObject = $refinementBar.length > 0 ? $refinementBar.data('refconfig') : {};

        $refinementValues.not('.allways-visible').removeClass('visible').addClass('visually-hidden');
        $showMoreLink.removeClass('initially-hidden').removeClass('visually-hidden').addClass('visible');
        $hideMoreLink.removeClass('visible').addClass('visually-hidden');

        if ($refinementBar.length > 0) {
            delete urlExtensionObject[refParameter];
            $refinementBar.attr('data-refconfig', JSON.stringify(urlExtensionObject));
        }
    }
}

/**
 * @param {string} res - result to be parsed into HTML
 * @returns {JQuery} parsed result
 */
function modifyRefinementsForResult(res) {
    const $parsedResult = $($.parseHTML(res, document, true));
    const refinementsType = getRefinementsType();
    if (refinementsType === 'top') {
        const $refinementsMobile = $('.refinements-mobile.mr-active');
        let newMobileRefinements;
        $('.refinements-desktop .refinement-select.toggle.expanded').each(function () {
            const $newRefinement = $parsedResult.find(
                `.refinements-desktop .refinement.${$(this).parents('.refinement').data('attrid')}`
            );
            $newRefinement.find('.toggle').addClass('expanded').attr('aria-expanded', 'true');
            $newRefinement.find('.toggle-content').show();
        });
        if ($refinementsMobile.length) {
            newMobileRefinements = $parsedResult.find('.refinements-mobile').addClass('mr-active');
            $('.refinements-mobile .refinement .flyin.mrsc-active').each(function () {
                newMobileRefinements
                    .find(`.refinement.${$(this).parents('.refinement').data('attrid')} .flyin`)
                    .addClass('mrsc-active');
            });
        }
    } else if (refinementsType === 'side') {
        $('.refinement-dropdowns .refinement-select.toggle').each(function () {
            const attrid = $(this).parents('.refinement').data('attrid');
            const $newRefinement = $parsedResult.find(`.refinement-dropdowns .refinement.${attrid}`);
            const isExpanded = $(this).hasClass('expanded');
            if (isExpanded) {
                $newRefinement.find('> refinement-dropdown > .toggle').addClass('expanded');
                $newRefinement.find('.toggle').attr('aria-expanded', 'true');
                $newRefinement.find('> refinement-dropdown > .toggle-content').show();
            } else {
                $newRefinement.find('> refinement-dropdown > .toggle').removeClass('expanded');
                $newRefinement.find('> refinement-dropdown > .toggle-content').hide();
            }
        });
    }

    return $parsedResult;
}

/**
 * @param {Object?} event - This method also used in a subscription which will pass JS event here
 * @param {Function?} event.afterRerenderCallback - A callback to be called after the filters got rerendered
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the
 *              product listing
 */
export const updateProductListing = event => {
    const hash = window.location.search;
    const currentUrl = window.location.href;
    let refineUrl;
    let requestUrl = '';
    let refConfig = {};
    let refinementsType;

    if (hash === undefined || currentUrl === undefined) {
        return;
    }

    if (hash !== undefined && hash.length > 0 && hash !== 'results-content' && hash !== 'results-products') {
        refineUrl = window.location.pathname + hash;
        refConfig = getRefConfig();

        if (!$.isEmptyObject(refConfig)) {
            refineUrl = util.appendParamsToUrl(refineUrl, refConfig);
        }

        requestUrl = refineUrl;
    } else {
        requestUrl = window.location.href;
    }

    if (requestUrl.length > 0) {
        const typeStateParam = getRefinementTypeState();
        if (typeStateParam) {
            requestUrl = util.appendParamsToUrl(requestUrl, typeStateParam);
        }

        progress.show($('.search-result-content'));
        $.get(util.appendParamToURL(requestUrl, 'format', 'ajax')).done(function (res) {
            const modifiedResult = modifyRefinementsForResult(res);
            const $container = $('#main');

            const scrollTop = $(window).scrollTop();
            $container.empty().append(modifiedResult);
            $(window).scrollTop(scrollTop);
            refinementsType = getRefinementsType();
            reInitSections(scrollOffset);

            if (refinementsType === 'top') {
                const $scrollTarget = $('.search-result-options');
                if ($scrollTarget.length) {
                    // scroll to begin of product listing on mobile
                    util.scrollBrowser($scrollTarget.offset().top - 56);
                }
            }

            if (event?.detail?.trackingData) {
                const {trackingData} = event.detail;
                const {refineAction, refinementForTrackingString, refinementsForTrackingString} = trackingData;
                const numberOfResults = $('.paging-info-count').data('productsCount');
                tracking.plpFilterChange(
                    refineAction,
                    refinementForTrackingString,
                    refinementsForTrackingString,
                    numberOfResults
                );
            }

            const applyBtn = $('#refinements-apply');
            const refContainer = $('.filters_2019');

            if (applyBtn && applyBtn.length && refContainer && refContainer.length) {
                const selectedFilters = $('.refinement-relax');
                const selectionClass = 'selection-changed';

                if (!refContainer.hasClass(selectionClass) && selectedFilters && selectedFilters.length) {
                    refContainer.addClass(selectionClass);
                    if (window.SitePreferences.HIDE_SEO_TEXT_ON_REFINEMENT) {
                        $('.js-bottom-category-seo').addClass('hidden');
                    }
                }
            }

            event?.afterRerenderCallback?.();
        });
    }
};

/**
 * NEW product sorting handler 2019
 *
 * @returns {boolean} false
 */
function updateProductSorting() {
    const mainEl = $('#dropdown__selected');
    let refineUrl = mainEl.data('value');
    const refConfig = getRefConfig();
    let queryString = '';

    if (!$.isEmptyObject(refConfig)) {
        refineUrl = util.appendParamsToUrl(refineUrl, refConfig);
    }

    queryString = util.getQueryString(refineUrl);
    if (queryString && queryString.length > 1) {
        // window.location.hash = query;
        const targetURL = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}?${queryString}`;
        window.history.pushState(window.history.state, document.title, targetURL);
        updateProductListing();
    } else {
        window.location.href = refineUrl;
    }

    return false;
}

/**
 * @returns {Object|boolean} state or false
 */
function getRefinementTypeState() {
    let filtersState = localStorage.getItem('filter_type_state');
    const params = {};

    if (filtersState !== null) {
        filtersState = JSON.parse(filtersState);

        if (filtersState.expanded.length > 0) {
            params.ft_expanded = encodeURIComponent(filtersState.expanded.join('|'));
        }

        if (filtersState.collapsed.length > 0) {
            params.ft_collapsed = encodeURIComponent(filtersState.collapsed.join('|'));
        }

        return params;
    }
    return false;
}

/**
 * @param {Event} e - event
 */
function hideMoreRefinementsHandler(e) {
    const $refBar = $(this).closest('.refinements');
    e.preventDefault();
    hideAllFilters($refBar);
}

/**
 * @param {Event} e - event
 */
function showMoreRefinementsHandler(e) {
    const $refBar = $(this).closest('.refinements');
    e.preventDefault();
    showAllFilters($refBar);
}

/**
 * Handles the size tab
 */
function sizeTabHandler() {
    $('.size-tab').removeClass('active');
    $(this).addClass('active');
    $('.USgroup').hide();
    $('.EUgroup').hide();
    $(`.${$(this).text()}group`).show();
}

/**
 * @param {Event} e - event
 */
function showMoreValuesHandler(e) {
    const $valList = $(this).closest('.refinement');
    e.preventDefault();
    showAllValues($valList);
}

/**
 * @param {Event} e - event
 */
function hideMoreValuesHandler(e) {
    const $valList = $(this).closest('.refinement');
    e.preventDefault();
    hideAllValues($valList);
}

/**
 * @param {Event} e - event
 */
const loadMoreHandler = async e => {
    e.preventDefault();
    if (ConstructorIOSearch.isEnabled) {
        await handleLoadMoreConstructor(ConstructorIOSearch, e.currentTarget);
    } else {
        updateHistoryWithAdditionalProducts();
        loadAdditionalProducts();
    }
};

/**
 * Handles the compare check.
 */
function compareCheckHandler() {
    const $cb = $(this);
    const tile = $cb.closest('.product-tile');

    const func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
    const itemImg = tile.find('.product-image a img').first();
    func({
        itemid: tile.data('itemid'),
        uuid: tile[0].id,
        img: itemImg,
        cb: $cb
    });
}

/**
 * @param {Event} e - event
 */
function updateGridHandler(e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
    }
    const $this = $(this);
    let query = '';

    if ($this.parent().hasClass('unselectable') || $this.hasClass('info-link')) {
        return;
    }
    if ($this.hasClass('function-link') || $this.hasClass('a-level') || $this.hasClass('.flyin-close')) {
        e.preventDefault();
        return;
    }

    const catparent = $this.parents('.category-refinement');
    const folderparent = $this.parents('.folder-refinement');

    // if the anchor tag is underneath a div with the class names & , prevent the double encoding of the url
    // else handle the encoding for the url
    if ((catparent && catparent.length > 0) || (folderparent && folderparent.length > 0)) {
        return;
    }
    e.preventDefault();
    query = util.getQueryString(this.href || this.getAttribute('data-href'));
    if (query && query.length > 1) {
        // window.location.hash = query;
        const {location} = window;
        const targetURL = `${location.protocol}//${location.hostname}${location.pathname}?${query}`;
        window.history.pushState(window.history.state, document.title, targetURL);
        updateProductListing();
    } else {
        window.location.href = this.href || this.getAttribute('data-href');
    }
}

/**
 *
 * Returns 1 unique value only or undefined.
 *
 * @param {string} stringedValue - url params.
 * @returns {string|null} unique value.
 */
const getUniqueParamValues = stringedValue => {
    if (stringedValue) {
        // Get only unique values, as we have duplicates because of EU/UK measures for example.
        let separator = stringedValue.includes(',') ? ',' : '|';

        if (stringedValue.includes('wsize') || stringedValue.includes('msize') || stringedValue.includes('ksize')) {
            separator = '|';
        }

        const valuesArr = stringedValue.split(separator).filter((x, i, a) => a.indexOf(x) === i);

        if (valuesArr.length === 1) {
            return encodeURIComponent(valuesArr[0]);
        }
    }

    return null;
};

/**
 *
 * Returns size/width params if only one size/width is selected.
 *
 * @param {Object} params - url params.
 * @returns {Object} selected filters.
 */
const getSelectedFilters = params => {
    const selectedFilters = {};

    let selectedSizes;
    let selectedWidths;

    Object.keys(params).forEach(key => {
        // URL params are mapped prefn1:'sizeName', prefv1:'36;3.5'.
        if (params[key] === 'sizeName') {
            // Find value for wanted param.
            selectedSizes = params[key.replace('n', 'v')];
        }

        if (params[key] === 'width' && key !== 'removedprev') {
            selectedWidths = params[key.replace('n', 'v')];
        }

        // Constructor filters.
        if (key.includes('sizeName')) {
            selectedSizes = params[key].replace(/"/g, '');
        }

        if (key.includes('width')) {
            selectedWidths = params[key].replace(/"/g, '');
        }
    });

    if (selectedWidths) {
        const selectedWidth = getUniqueParamValues(selectedWidths);

        if (selectedWidth) {
            selectedFilters.selectedWidth = selectedWidth;
        }
    }

    if (selectedSizes) {
        const selectedSize = getUniqueParamValues(selectedSizes);

        if (selectedSize) {
            selectedFilters.selectedSize = selectedSize;
        }
    }

    return selectedFilters;
};

/**
 * Handles product tile interaction
 */
function productTileHandler() {
    const $a = $(this);
    // get current page refinement values
    const wl = window.location;

    const qsParams = wl.search.length > 1 ? util.getQueryStringParams(wl.search.substr(1)) : {};
    const hashParams = wl.hash.length > 1 ? util.getQueryStringParams(wl.hash.substr(1)) : {};

    // simply replace plus sign to avoid wrong search strings
    if (Object.prototype.hasOwnProperty.call(qsParams, 'q')) {
        // eslint-disable-line no-prototype-builtins
        qsParams.q = qsParams.q.replace('+', ' ');
    }

    // simply replace plus sign to avoid wrong search strings
    if (Object.prototype.hasOwnProperty.call(hashParams, 'q')) {
        // eslint-disable-line no-prototype-builtins
        hashParams.q = hashParams.q.replace('+', ' ');
    }

    // merge hash params with querystring params
    // params = $.extend(hashParams, qsParams);
    const params = !$.isEmptyObject(hashParams) ? hashParams : qsParams;

    if (params && SitePreferences.ENABLE_PLP_PRESELECT) {
        const selectedFilters = getSelectedFilters(params);

        if (selectedFilters) {
            $a.attr('href', util.appendParamsToUrl($a.attr('href'), selectedFilters));
        }
    }

    // set the hash and allow normal action to continue
    $a[0].hash = $.param(params);
}

/**
 * @returns {boolean} false
 */
async function sortHandler() {
    const $selectedOption = $(this).find('option:selected');
    if (ConstructorIOSearch.isEnabled) {
        await handleSortConstructor(ConstructorIOSearch, $selectedOption[0]);
        return false;
    }
    let refineUrl = $selectedOption.val();
    const refConfig = getRefConfig();
    let queryString = '';

    if (!$.isEmptyObject(refConfig)) {
        refineUrl = util.appendParamsToUrl(refineUrl, refConfig);
    }

    queryString = util.getQueryString(refineUrl);
    if (queryString && queryString.length > 1) {
        // window.location.hash = query;
        const {location} = window;
        const targetURL = `${location.protocol}//${location.hostname}${location.pathname}?${queryString}`;
        window.history.pushState(window.history.state, document.title, targetURL);
        updateProductListing();
    } else {
        window.location.href = refineUrl;
    }

    return false;
}

/**
 * Handles changing the amount of items per page
 *
 * @returns {false} false
 */
function changeItemsPerPageHandler() {
    const refineUrl = $(this).find('option:selected').val();
    const queryString = util.getQueryString(refineUrl);
    if (refineUrl === 'INFINITE_SCROLL') {
        $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
    } else {
        $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
        window.location.hash = queryString;
    }
    return false;
}

/**
 * Storing the last visited search page URL into cookies for the "Continue Shopping" functionality
 */
function saveLastVisitedSearchURL() {
    cookie.set(LAST_VISITED_SEARCH_COOKIE, window.location.href);
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    const $main = $('#main');

    // iOS doesn't support beforeunload, so also add pagehide event.
    $window.on('beforeunload pagehide', storeScrollPosition);

    // handle events for size tab
    $main.on('click', 'a.hide-more-refinements', hideMoreRefinementsHandler);
    // handle events for show all filters
    $main.on('click', 'a.show-more-refinements', showMoreRefinementsHandler);

    // handle events for hide filters
    $main.on('click', '.size-tab', sizeTabHandler);

    // handle events for show all values
    $main.on('click', 'a.show-more-values', showMoreValuesHandler);

    // handle events for hide values
    $main.on('click', 'a.hide-more-values', hideMoreValuesHandler);

    // handle events to load more products
    $main.on('click', '.show-more-products-button button', loadMoreHandler);

    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', compareCheckHandler);

    // handle events for updating grid
    $main.on(
        'click',
        '.refinements a, .refinements span[role=link], .pagination a, .breadcrumb-refinement-value a',
        updateGridHandler
    );
    $main.on('keydown', '.refinements span[role=link]', updateGridHandler);

    // handle events item click. append params.
    $main.on('click', '.search-result-content .product-tile', productTileHandler);

    // handle sorting change
    $main
        .on('change', '.sort-by select', sortHandler)
        .on('change', '.items-per-page select', changeItemsPerPageHandler);

    saveLastVisitedSearchURL();
    initSizeTabs();
    initMobilerefinements();
    wishlist.init();

    let updateListingFunction = updateProductListing;
    let updateSortingFunction = updateProductSorting;
    if (ConstructorIOSearch.isEnabled) {
        /**
         * @async
         * @returns {Function} Callback for when Constructor.io is enabled
         */
        updateListingFunction = async () => {
            await handleRefinementsConstructor(ConstructorIOSearch);
        };
        /**
         * @async
         * @returns {Function} Callback for when Constructor.io is enabled
         */
        updateSortingFunction = async () => {
            await handleSortConstructor(ConstructorIOSearch);
        };
    }
    // handle hash change
    window.addEventListener('hashchange', updateListingFunction);

    if (!isMac() && !isDeviceiOS()) {
        window.addEventListener('popstate', updateListingFunction);
    }

    window.addEventListener('plp.updateproductlisting', updateListingFunction);
    window.addEventListener('plp.sortingupdated', function (event) {
        scrollOffset = event.detail.scrollOffset;
        updateSortingFunction();
    });
    updateCustomDropdown();
}

/**
 * Init function
 */
export const init = () => {
    compareWidget.init();
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', infiniteScroll);
    }
    productTileInit();
    colorSwatchInit();
    applyShowMoreProductsStyle();
    initializeEvents();
};
